// extracted by mini-css-extract-plugin
export var actionText = "_m8-4";
export var container = "_m8-0";
export var leftSection = "_m8-1";
export var rightSection = "_m8-2";
export var settingsButton = "_m8-6";
export var settingsIcon = "_m8-7";
export var shortcut = "_m8-5";
export var shortcutGroup = "_m8-3";